import { useCallback, useEffect, useState } from "react";
import { PublicPageStyle } from "../../constants/styles";
import { GroupDataType, LinkDataType, RouterType } from "../../constants/types";
import LinkTemplate from "../templates/LinkTemplate";
import { getLinks, getQuantityGroup } from "../../api/link";

const LinkPage = (props: RouterType) => {
  const [qty, setQty] = useState<GroupDataType>({
    total: 0,
    disconnectedTotal: 0,
    list: [],
  });
  const [links, setLinks] = useState<LinkDataType[]>([]);

  const getQtyData = useCallback(async () => {
    const quantity = await getQuantityGroup();
    setQty(quantity);
  }, []);

  const getLinkData = useCallback(async () => {
    const links = await getLinks();
    setLinks(links);
  }, []);

  useEffect(() => {
    getQtyData();
  }, [props.render]);

  useEffect(() => {
    getLinkData();
  }, []);

  return (
    <PublicPageStyle>
      <LinkTemplate qty={qty} links={links} />
    </PublicPageStyle>
  );
};

export default LinkPage;
